module.exports = __webpack_public_path__ + "res/32-img_play.7e2db3ab0578be26bc4a49e5749c7d31.png";